// 司机端接送机包车主页 - 导航页面
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@/i18n';
import './index.scss';

const AirportTransferIndex = () => {
  const history = useHistory();
  const t = useTranslation();

  const navigateToHall = () => {
    history.push('/airportTransfer/hall');
  };

  const navigateToRecord = () => {
    history.push('/airportTransfer/record');
  };

  return (
    <div className="airport-transfer-index">
      <div className="index-header">
        <h1 className="index-title">{t('airportTransfer.index.title')}</h1>
        <p className="index-subtitle">{t('airportTransfer.index.subtitle')}</p>
      </div>

      <div className="index-content">
        <div className="nav-card" onClick={navigateToHall}>
          <div className="card-icon">🚗</div>
          <div className="card-title">{t('airportTransfer.index.hallTitle')}</div>
          <div className="card-desc">{t('airportTransfer.index.hallDesc')}</div>
          <div className="card-arrow">→</div>
        </div>

        <div className="nav-card" onClick={navigateToRecord}>
          <div className="card-icon">📋</div>
          <div className="card-title">{t('airportTransfer.index.recordTitle')}</div>
          <div className="card-desc">{t('airportTransfer.index.recordDesc')}</div>
          <div className="card-arrow">→</div>
        </div>
      </div>

      <div className="index-footer">
        <p className="footer-tips">💡 {t('airportTransfer.index.tips')}</p>
      </div>
    </div>
  );
};

export default AirportTransferIndex;
